export default __webpack_public_path__ + "static/media/cardType.0d92cb6e.svg";